import moment from 'moment'

const CalculateTimeString = ({ data, attribute }) => {
    const { item } = data
    const size = attribute?.component?.size || 'default'
    const calculateFromDate = attribute?.component?.calculateFromDate || false

    const calculateTimeFromDate = (dateString) => {
        if (!dateString) return null

        const date = moment(dateString)
        const now = moment()
        const duration = moment.duration(now.diff(date))

        const days = Math.floor(duration.asDays())
        const hours = duration.hours()
        const minutes = duration.minutes()

        return { days, hours, minutes }
    }

    const getTimeInString = (value) => {
        if (!value) return null

        let days = 0,
            hours = 0,
            minutes = 0

        // Check if value is a date string (ISO format) and calculateFromDate is enabled
        if (
            calculateFromDate &&
            typeof value === 'string' &&
            value.includes('T')
        ) {
            const calculated = calculateTimeFromDate(value)
            if (calculated) {
                days = calculated.days
                hours = calculated.hours
                minutes = calculated.minutes
            } else {
                return null
            }
        } else {
            // Original format: "65:18:10" (days:hours:minutes)
            const splitted = value.split(':')
            if (splitted && splitted[0] && splitted[0].length) {
                days = +splitted[0] || 0
            }
            if (splitted && splitted[1] && splitted[1].length) {
                hours = +splitted[1] || 0
            }
            if (splitted && splitted[2] && splitted[2].length) {
                minutes = +splitted[2] || 0
            }
        }

        // Format based on size
        if (size === 'small') {
            return `${days}d ${hours}h ${minutes}m`
        }
        return `${days} days ${hours} hours ${minutes} mins`
    }

    return (
        <>
            {item && item[attribute.name] === null
                ? '-'
                : getTimeInString(item[attribute.name])}
        </>
    )
}
export default CalculateTimeString
